import { AfterViewInit, Directive, ElementRef, inject, input, InputSignal, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SwiperContainer } from 'swiper/swiper-element';
import { SwiperOptions } from 'swiper/types';

@Directive({
  selector: '[braidsbookSwiper]'
})
export class SwiperDirective implements AfterViewInit {
  swiperContainer: SwiperContainer = inject(ElementRef<SwiperContainer>).nativeElement;
  swiperOptions: InputSignal<SwiperOptions | undefined> = input<SwiperOptions | undefined>(undefined);

  readonly #platformId = inject(PLATFORM_ID);


  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.#platformId)) return;
    if (!this.swiperContainer.swiper) {
      Object.assign(this.swiperContainer, this.swiperOptions());
      this.swiperContainer.initialize();
    }
    // Swiper pose `.swiper-initialized` sur le `.swiper` de son shadow DOM, pas
    // sur l'hôte : on marque l'hôte nous-mêmes pour lever le masquage pré-init
    // (voir styles.scss).
    this.swiperContainer.classList.add('swiper-ready');
  }

}
